<app-sidebar [isOpen]="open" (close)="sidebarCancel()" [bigSize]="false">
  @if (open) {
    <div class="excel-management-sidebar astral-sidebar-shell">
      <div class="excel-management-sidebar__content astral-sidebar-content astral-stack-m">
        <section class="astral-stack-s">
          <h4>{{ 'EXCEL_EXPORT_SETTINGS.SELECT_EXPORT_METHOD' | translate }}</h4>
          <astral-radio-group [caption]="''" [control]="form.controls['radioButtons']" [items]="radioGroupItems"></astral-radio-group>
          <app-information-block [text]="'EXCEL_EXPORT_SETTINGS.EXPORT_PREFERENCES_INFO' | translate"></app-information-block>
          @if (showRadioCheckbox) {
            <astral-checkbox
              class="excel-management-sidebar__checkbox"
              [checked]="isApplySelectionChecked"
              [label]="currentCheckboxDisplayName"
              [variant]="'compact'"
              (checkedChange)="onApplySelectionChange($event)"
            ></astral-checkbox>
          }
        </section>

        <section class="excel-management-sidebar__column-section astral-stack-s">
          <div class="excel-management-sidebar__sticky-header astral-stack-s">
            <h4>{{ title | translate }}</h4>
            <astral-input
              class="excel-management-sidebar__search"
              [control]="form.controls['searchFilter']"
              [placeholderText]="searchCaption"
              [withShell]="false"
            ></astral-input>
          </div>

          @if (form.controls['searchFilter'].value) {
            <ul class="excel-management-sidebar__list">
              @for (item of sidebarItems | keywordFilter : form.controls['searchFilter'].value : 'caption'; track item) {
                <li class="excel-management-sidebar__item">
                  <astral-checkbox
                    [checked]="item.selected"
                    [label]="item.caption"
                    [variant]="'compact'"
                    (checkedChange)="setItemSelected(item, $event)"
                  ></astral-checkbox>
                </li>
              }
            </ul>
          }

          @if (!form.controls['searchFilter'].value) {
            <div class="excel-management-sidebar__selection-controls">
              <astral-checkbox
                [checked]="checkAllSelected()"
                [disabled]="isListViewModeSelected"
                [label]="'SELECT_ALL'"
                [variant]="'compact'"
                (checkedChange)="toggleAll($event)"
              ></astral-checkbox>
              <astral-button
                variant="secondary"
                size="small"
                type="button"
                labelKey="COMMON.RESET"
                [disabled]="isListViewModeSelected"
                (click)="restoreDefaults()"
              ></astral-button>
            </div>

            @if (selectedItems.length > 0) {
              <div class="excel-management-sidebar__section-header">
                <h5>{{ 'SELECTED' | translate }}</h5>
                @if (reorderable) {
                  <astral-popover [helpText]="'REORDER_HELPTEXT'"></astral-popover>
                }
              </div>

              <ul
                class="excel-management-sidebar__list excel-management-sidebar__list--reorderable"
                cdkDropList
                [cdkDropListDisabled]="!reorderable"
                [cdkDropListData]="selectedItems"
                (cdkDropListDropped)="drop($event)"
              >
                @for (item of selectedItems; track item) {
                  <li cdkDrag cdkDragLockAxis="y" cdkDragBoundary=".excel-management-sidebar__list--reorderable" class="excel-management-sidebar__item">
                    <astral-checkbox
                      [checked]="item.selected"
                      [disabled]="isListViewModeSelected"
                      [label]="item.caption"
                      [variant]="'compact'"
                      (checkedChange)="setItemSelected(item, $event)"
                    ></astral-checkbox>
                    @if (reorderable) {
                      <div class="excel-management-sidebar__move" cdkDragHandle></div>
                    }
                  </li>
                }
              </ul>
            }

            @if (!isListViewModeSelected && deselectedItems.length > 0) {
              <div class="excel-management-sidebar__section-header">
                <h5>{{ 'AVAILABLE' | translate }}</h5>
              </div>
              <ul class="excel-management-sidebar__list">
                @for (item of deselectedItems; track item) {
                  <li class="excel-management-sidebar__item">
                    <astral-checkbox
                      [checked]="item.selected"
                      [label]="item.caption"
                      [variant]="'compact'"
                      (checkedChange)="setItemSelected(item, $event)"
                    ></astral-checkbox>
                  </li>
                }
              </ul>
            }

            @if (!isListViewModeSelected && sidebarAdditionalSheetItems.length > 0) {
              <div class="excel-management-sidebar__section-header">
                <h5>{{ 'EXCEL_EXPORT_SETTINGS.ADDITIONAL_SHEETS' | translate }}</h5>
                <astral-popover [helpText]="'EXCEL_EXPORT_SETTINGS.ADDITIONAL_SHEETS_INFO' | translate"></astral-popover>
              </div>
              <ul class="excel-management-sidebar__list">
                @for (item of sidebarAdditionalSheetItems; track item.binding) {
                  <li class="excel-management-sidebar__item">
                    <astral-checkbox
                      [checked]="item.selected"
                      [label]="item.caption"
                      [variant]="'compact'"
                      (checkedChange)="setAdditionalSheetSelected(item, $event)"
                    ></astral-checkbox>
                  </li>
                }
              </ul>
            }
          }
        </section>
      </div>

      <div class="excel-management-sidebar__footer astral-sidebar-footer">
        <astral-button
          variant="primary"
          type="button"
          labelKey="COMMON.EXCEL_EXPORT"
          [disabled]="validate ? !isAnyCheckboxSelected() : false"
          (click)="sidebarSave()"
          [appTooltip]="'VALIDATE_COLUMNS_CHANGE' | translate"
          [tooltipDisabled]="!validate || isAnyCheckboxSelected()"
        ></astral-button>
        <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="sidebarCancel()"></astral-button>
      </div>
    </div>
  }
</app-sidebar>
